import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./ManaFalafel.Meal.scss"

class FalaFelMeal extends Component {
    constructor(props) {
        super()
        this.state = {
            isChoosen: false,
            displayArrow: true
        }
        this.chooseMeal = this.chooseMeal.bind(this);
    }

    componentDidUpdate() {
        console.log(this.state.displayArrow)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.item.ID == this.props.removeSelected) {
            this.setState({
                isChoosen: false,
            })
        }
        if (this.props.item.ID == this.props.chooseMeal) {
            this.chooseMeal();
        }
    }
    chooseMeal() {
        if (!this.state.isChoosen && this.props.current >= 3) {
            this.props.triggerPopup({
                Title: "לא ניתן לבחור יותר מ-3 שירים",
                Describe: ""
            }, "")
            return;
        }
        this.setState({
            isChoosen: !this.state.isChoosen
        })
        this.props.getMeal(this.props.item, (!this.state.isChoosen ? Math.round(this.props.current + 1) : Math.round(this.props.current - 1)));
    }
    render() {
        return (
            <div className={`mana${(this.state.isChoosen ? " active" : "")}`}>
                <div className="mana-padding">
                    <div className="headline">
                        <h5>
                            {this.props.item.Title}
                        </h5>
                        <h5>
                            {this.props.item.Describe}
                        </h5>
                    </div>
                    <div className="button" onClick={() => { push(`Song - ${(!this.state.isChoosen ? "Add to List" : "Removed From List")}`, "Button"); this.setState({displayArrow: !this.displayArrow}); this.chooseMeal(); }}>
                        <div className="arrow"></div>
                        <div className="button-text">
                            {`${(this.state.isChoosen ? "השיר נבחר" : "בחר שיר")}`}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FalaFelMeal;



// WEBPACK FOOTER //
// ./src/Components/ManotFalafel/ManaFalafel.Meal.jsx